export function toDecimalPlaces(number: number, decimalPlaces: number) {
    return Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
}
